module.exports = __webpack_public_path__ + "img/icon-archive-light.228e1e4b.svg";